import { cognitoAxiosInstance } from 'config/axiosInstance'
import { ACCOUNTS } from 'resources/endpoints'
import { getToken } from 'services/amplify/auth'

const downloadProfile = async (accountId) => {
  const token = await getToken()
  const client = cognitoAxiosInstance(token)

  const response = await client.get(`${ACCOUNTS}/${accountId}/profile-data.json.zip`, { responseType: 'blob' })

  // Create and auto-click an anchor to trigger downloading the fetched blob as a zip file.
  // This will open a new tab with url=blob:http://<host>/<blob-as-a-string>.
  // Since the url of the anchor is a blob, browsers will prompt for download.
  const a = document.createElement('a')
  a.style = 'display: none'
  a.href = URL.createObjectURL(new Blob([response.data]))
  a.download = 'profile-data.zip'
  a.target = '_blank'
  a.click()
}

export default {
  downloadProfile,
}
